<template>
  <div id="vue-tinymce">
    <vue-tinymce v-model="editorValue" :setting="setting" />
  </div>
</template>

<script>
export default {
  name: "TinymceEditor",
  data() {
    return {
      editorValue: "",
      setting: {
        menubar: false, // 菜单栏
        //inline: true,   //开启内联模式
        readonly: false, // 只读
        toolbar:
          // "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table emoticons | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat | wordcount code",
          "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | table emoticons | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat | wordcount code",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar:
          "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        // plugins: "link image media table lists fullscreen quickbars wordcount paste emoticons code",
        plugins:
          "link image media table lists fullscreen wordcount paste emoticons code",
        language: "zh-Hans",
        height: 350,
        // 图片上传地址(自动上传)
        // images_upload_url: baseUploadUrl + 'image/vueTinymce/',
        // 允许粘贴图片上传,及格式
        paste_data_images: true,
        images_file_types: "jpeg,jpg,png,gif,bmp,webp",
        // 此处为图片上传处理函数 (手动上传)
        images_upload_handler: (blobInfo, success, failure, progress) => {
          console.log("上传处理器：");
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          //   xhr.open("POST", baseUploadUrl + "image/vueTinymce/");
          //   xhr.upload.onprogress = function(e) {
          //     progress((e.loaded / e.total) * 100);
          //   };
          //   // 成功结果
          //   xhr.onload = function() {
          //     if (xhr.status != 200) {
          //       failure("HTTP Error: " + xhr.status, { remove: true });
          //       return;
          //     }
          //     const json = JSON.parse(xhr.responseText);
          //     success(json.data.url);
          //   };
          //   // 失败结果
          //   xhr.onerror = function() {
          //     failure(
          //       "Image upload failed due to a XHR Transport error. Code: " +
          //         xhr.status
          //     );
          //   };
          //   // 请求数据
          //   const formData = new FormData();
          //   formData.append("file", blobInfo.blob(), blobInfo.filename());
          //   xhr.send(formData);
        }
      }
    };
  },
  // components:{
  //     Editor: Editor
  // },
  props: {
    content: String
  },
  watch: {
    editorValue: function(newVal, oldVal) {
      // 修改调用者传入的值
      this.$emit("update:content", newVal);
    },
    content: function(newVal) {
      if (this.content != null) {
        this.editorValue = this.content;
      } else {
        this.editorValue = "";
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/tinymce/TinymceEditor.vue